import {ButtonHTMLAttributes, ReactElement} from "react";
import {Overlay} from "@/widgets/Overlay";
import {ModalBody, ModalHeader} from "@/widgets/ModalParts";
import {Button} from "@/components/buttons/Button";
import DOMPurify from "dompurify";
import {FaGlobe} from "react-icons/fa";
import {useOpenPromoTokenLink} from "@/hooks/useOpenPromoTokenLink";

interface Props {
    description?: string;
    distributedRewardId: string;
    isOpen: boolean;
    toggle: () => void;
}

function PromoTokenExternalUrlModal(props: Props): ReactElement {
    const openLink = useOpenPromoTokenLink();

    async function handleOpenReward(): Promise<void> {
        const redirectPath = await openLink.mutateAsync(props.distributedRewardId);
        window.open(redirectPath, "_blank", "noopener,noreferrer");
    }

    return (
        <Overlay
            isOpen={props.isOpen}
            toggle={props.toggle}
            contentClassName="promo-token-external-url-modal"
            size="sm"
        >
            <ModalHeader
                title="Claim Reward"
                toggle={props.toggle}
            />

            <ModalBody>
                {props.description &&
                    <div
                        className="promo-token-external-url-modal_description"
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(props.description)}}
                    />
                }

                <div className="promo-token-external-url-modal_actions">
                    <Button variant="primary"
                        onClick={handleOpenReward}
                        loading={openLink.isPending}
                        leftIcon={FaGlobe}
                    >
                        Open Reward
                    </Button>
                </div>
            </ModalBody>
        </Overlay>
    );
}

export default PromoTokenExternalUrlModal;
